import { render, staticRenderFns } from "./orderDetails.vue?vue&type=template&id=09db4feb&scoped=true"
import script from "./orderDetails.vue?vue&type=script&lang=js"
export * from "./orderDetails.vue?vue&type=script&lang=js"
import style0 from "../../style/common-pc.scss?vue&type=style&index=0&id=09db4feb&prod&lang=scss&scoped=true&external"
import style1 from "./orderDetails.vue?vue&type=style&index=1&id=09db4feb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../content-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09db4feb",
  null
  
)

export default component.exports